import * as PropTypes from 'prop-types';

export const withToastPropTypes = {
  setToastMessage: PropTypes.func,
};
